/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceDto } from '../../models/device-dto';

export interface DeviceControllerFindAllByClientId$Params {
  clientWorkspaceId: string;
  query: string;
}

export function deviceControllerFindAllByClientId(http: HttpClient, rootUrl: string, params: DeviceControllerFindAllByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceDto>>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerFindAllByClientId.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DeviceDto>>;
    })
  );
}

deviceControllerFindAllByClientId.PATH = '/api/device/all/{clientWorkspaceId}';
